import React, { useMemo } from 'react'
import { SocialAccount } from 'types/influencer';
import "../style.scss";
import { formatNumber, getSocialAccountProfileURL } from 'utils/helpers';

interface SocialAccountProfileProps {
    socialAccount: SocialAccount;
    name: string;
    handle: string;
    followersCount: number;
    gender?: string;
    location?: string;
    age?: string;
    niches?: string[];
}

const formatAgeTag = (age: string): string => {
    const trimmed = age.trim();
    return `${trimmed} Yrs`;
};

const SocialAccountProfile: React.FC<SocialAccountProfileProps> = ({
    socialAccount,
    name,
    handle,
    followersCount,
    gender,
    location,
    age,
    niches = [],
}) => {
    const followersDisplay = formatNumber(followersCount);

    const displayHandle = handle.startsWith('@') ? handle : `@${handle}`;
    const platform = socialAccount.platform

    const metadataTags = useMemo(() => {
        const tags: string[] = [];
        if (gender) tags.push(gender);
        if (location) tags.push(location);
        if (age) tags.push(formatAgeTag(age));
        if (niches && niches.length > 0) {
            const filteredNiches = niches.filter(Boolean);
            tags.push(...filteredNiches);
        }
   
        return tags;
    }, [gender, location, age, niches]);

    return (
        <div className="social-account-profile">
            <div className="social-account-profile__header">
                <div className="social-account-profile__avatar-wrap">
                    <div className="social-account-profile__avatar">
                        <img
                            alt={name || 'Profile'}
                            className="social-account-profile__avatar-img"
                            src={socialAccount.profile_picture_url.split('=')[0]}
                            referrerPolicy="no-referrer"
                        />
                    </div>
                    {platform === 'ig' ? (
                        <div className="ig-logo-space" aria-label="instagram">
                            <div className="ig-logo" aria-hidden />
                        </div>
                    ) : platform === 'yt' ? (
                        <div className="ig-logo-space" aria-label="youtube">
                            <i className="ri-youtube-fill fs-16px text-danger" aria-hidden />
                        </div>
                    ) : null}
                </div>
                <div className="social-account-profile__main">
                    <div className="social-account-profile__identity">
                        <p className="social-account-profile__name">
                            {name}
                            <a href={getSocialAccountProfileURL(handle, platform)} target="_blank" className='ms-1' rel="noopener noreferrer">
                                <i className="ri-external-link-line fs-14px" />
                            </a>
                        </p>
                        {/* <p className="social-account-profile__handle">{displayHandle}</p> */}
                    </div>
                    <div className="social-account-profile__followers">
                        <p className="social-account-profile__followers-count">{followersDisplay}</p>
                        <p className="social-account-profile__followers-label">{socialAccount.platform === 'ig' ? 'Followers' : 'Subscribers'}</p>
                    </div>
                </div>
            </div>
            {metadataTags.length > 0 && (
                <div className="social-account-profile__tags">
                    {metadataTags.map((tag, index) => (
                        <span className="social-account-profile__tag" key={`${tag}-${index}`}>
                            {tag}
                        </span>
                    ))}
                </div>
            )}
        </div>
    )
}

export default SocialAccountProfile
